import { render, staticRenderFns } from "./PropertiesImportModal.vue?vue&type=template&id=e1531388"
import script from "./PropertiesImportModal.vue?vue&type=script&lang=js"
export * from "./PropertiesImportModal.vue?vue&type=script&lang=js"
import style0 from "./PropertiesImportModal.vue?vue&type=style&index=0&id=e1531388&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports